'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FullScreenOverlay = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _basePortal = require('@bibliocommons/base-portal');

var _basePortal2 = _interopRequireDefault(_basePortal);

var _baseScreenReaderMessage = require('@bibliocommons/base-screen-reader-message');

var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);

var _baseAccessibilityManageFocus = require('@bibliocommons/base-accessibility-manage-focus');

var _baseAccessibilityManageFocus2 = _interopRequireDefault(_baseAccessibilityManageFocus);

var _baseIcons = require('@bibliocommons/base-icons');

require('../styles/FullScreenOverlay.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ESCAPE_KEY_NAME = 'Escape';
var ESCAPE_KEY_CODE = 27;

var FullScreenOverlay = exports.FullScreenOverlay = function (_BcReactComponent) {
  _inherits(FullScreenOverlay, _BcReactComponent);

  function FullScreenOverlay(props) {
    _classCallCheck(this, FullScreenOverlay);

    var _this = _possibleConstructorReturn(this, (FullScreenOverlay.__proto__ || Object.getPrototypeOf(FullScreenOverlay)).call(this, props));

    _this.bindAll('handleDocumentClick', 'handleCloseOnEscape', 'handleCloseIfOpen', 'handleClose');

    // Refs seem to have problems inside the Portal so we'll use ref callbacks and set these vars
    _this._overlayClose = null;
    _this._overlayFocusContent = null;
    _this._overlayContent = null;
    _this.overlayId = _lodash2.default.uniqueId('overlay');
    return _this;
  }

  _createClass(FullScreenOverlay, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var open = this.props.open;

      if (open) {
        this.handleToggleOpen(open);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.open !== prevProps.open) {
        this.handleToggleOpen(this.props.open);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.handleToggleOpen(false);
      this._overlayClose = null;
      this._overlayFocusContent = null;
      this._overlayContent = null;
    }
  }, {
    key: 'handleClose',
    value: function handleClose() {
      if (!this.props.disableClose) {
        return this.props.handleClose();
      }

      return false;
    }
  }, {
    key: 'handleCloseIfOpen',
    value: function handleCloseIfOpen() {
      if (this.props.open) {
        this.handleClose();
      }
    }
  }, {
    key: 'handleToggleOpen',
    value: function handleToggleOpen(open) {
      // Remove the event listener on close, and add on open
      var eventListener = open ? 'addEventListener' : 'removeEventListener';
      var toggle = open ? 'add' : 'remove';

      document[eventListener]('click', this.handleDocumentClick);
      document.body.classList[toggle]('overlay-is-open');
      document[eventListener]('keydown', this.handleCloseOnEscape);

      if (!this.props.disableHistoryControls) {
        window[eventListener]('popstate', this.handleCloseIfOpen);
      }

      if (open) {
        if (!this.props.disableHistoryControls) {
          window.history.pushState({ overlayId: this.overlayId }, '');
        }
        this.props.captureFocus(this._overlayFocusContent);
        this._overlayContent.scrollTop = 0;
      } else {
        this.props.restoreFocus();
        if (_lodash2.default.get(window, 'history.state.overlayId') === this.overlayId) {
          // Go back to remove the hash from the URL when overlay was closed without popstate
          window.history.back();
        }
      }
    }
  }, {
    key: 'handleDocumentClick',
    value: function handleDocumentClick(e) {
      // If clicking outside the overlay's content, call the close handler
      // This also works for the default close button which is outside the content
      if (this.props.open) {
        var content = this._overlayContent;
        if (content && !content.contains(e.target) && document.body.contains(e.target) && !e.target.isEqualNode(this._overlayClose)) {
          this.handleClose();
        }
      }
    }
  }, {
    key: 'handleCloseOnEscape',
    value: function handleCloseOnEscape(e) {
      if (e.key === ESCAPE_KEY_NAME || e.which === ESCAPE_KEY_CODE) {
        this.handleClose();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var classes = (0, _classnames2.default)('cp-full-screen-overlay', this.props.animation, this.props.className, { open: this.props.open });

      return _react2.default.createElement(
        'div',
        { className: classes, role: 'dialog', 'aria-hidden': !this.props.open, 'data-test-id': this.props['data-test-id'] },
        _react2.default.createElement('div', { className: 'overlay-backdrop' }),
        _react2.default.createElement(
          'div',
          { className: 'overlay-inner', ref: function ref(el) {
              _this2._overlayFocusContent = el;
            } },
          _react2.default.createElement(
            'div',
            { className: 'overlay-body', ref: function ref(el) {
                _this2._overlayContent = el;
              } },
            this.props.children
          ),
          _react2.default.createElement(
            'button',
            { className: 'overlay-close', tabIndex: 0, ref: function ref(el) {
                _this2._overlayClose = el;
              }, onClick: this.handleClose },
            _react2.default.createElement(
              'span',
              { 'aria-hidden': true },
              _react2.default.createElement(_baseIcons.Cross, null),
              ' '
            ),
            _react2.default.createElement(
              _baseScreenReaderMessage2.default,
              null,
              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'close_overlay' })
            )
          )
        )
      );
    }
  }]);

  return FullScreenOverlay;
}(_baseBcReactComponent2.default);

var overlayPropTypes = {
  animation: _react.PropTypes.oneOf(['simple-genie', 'slide-down', 'fade-in', 'instant']),
  open: _react.PropTypes.bool.isRequired,
  handleClose: _react.PropTypes.func,
  disableHistoryControls: _react.PropTypes.bool, // Pass this as true when using the router to control the overlay,
  disableClose: _react.PropTypes.bool
};

FullScreenOverlay.propTypes = _extends({}, overlayPropTypes, {
  captureFocus: _react.PropTypes.func.isRequired,
  restoreFocus: _react.PropTypes.func.isRequired
});

FullScreenOverlay.defaultProps = {
  animation: 'simple-genie',
  handleClose: _lodash2.default.noop,
  disableHistoryControls: false,
  disableClose: false
};

var PortaledOverlay = function PortaledOverlay(props) {
  return _react2.default.createElement(
    _basePortal2.default,
    null,
    _react2.default.createElement(FullScreenOverlay, props)
  );
};

var WrappedFullScreenOverlay = (0, _baseAccessibilityManageFocus2.default)(PortaledOverlay);

WrappedFullScreenOverlay.propTypes = _extends({}, overlayPropTypes, {
  handleFocusOnCapture: _react.PropTypes.func,
  handleFocusOnRestore: _react.PropTypes.func
});

exports.default = WrappedFullScreenOverlay;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-full-screen-overlay/lib/components/FullScreenOverlay.component.js
// module id = 888
// module chunks = 0 1